import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Configs } from '../interfaces/configs.interface';
import { Environment } from '../interfaces/environment.interface';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private config: Configs;

  /**
   * Config service aggregates different types of configs under one simple API
   */
  constructor() {
    const env: Environment = environment;
    this.config = {
      env,
    };
  }

  get(config: 'env', key: string): any {
    switch (config) {
      case 'env':
        return this.config.env[key] || undefined;
      default:
        return undefined;
    }
  }

  getEnv(): Environment {
    return this.config.env as Environment;
  }
}
